import { styled } from "styled-components";

export const ContentBodyStyled = styled.div`
  display: flex;
  padding: var(--Sizes---size-xl, 32px);
  flex-direction: column;
  align-items: center;
  gap: var(--Sizes---size-xl, 32px);
  align-self: stretch;
  margin-top: 32px;

  @media (max-width: 768px) {
    padding: 0px;
  }
`;

export const ContentButtonsStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

export const TitleSuccessStyled = styled.h1`
  flex: 1 0 0;
  margin: 0px;
  margin-top: 32px;
  color: ${({ theme }) => theme?.colors?.theme?.success};

  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 26px */
`;

export const TextInfoSuccessStyled = styled.div`
  align-self: stretch;
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 19.2px */
`;